import { FilterTypeItem } from "../components/shared/filter-type-autocomplete";

// Activity definitions with their display names
export const Activities = {
  ActionStatusRequiredEvidence: {
    value: "action.status_required_evidence",
    displayName: "Action status required evidence updated",
  },
  ActionCustomStatusLabel: {
    value: "action.custom_status_label",
    displayName: "Action status label updated",
  },
  ActionEditFieldsConfig: {
    value: "action.edit_fields_config",
    displayName: "Action edit fields config updated",
  },
  ActionStatusAccessConfig: {
    value: "action.status_access_config",
    displayName: "Action status access config updated",
  },
  ActionOrgStandaloneActionAccessConfig: {
    value: "action.org_standalone_action_access_config",
    displayName: "Action organisation standalone action access config updated",
  },
  ActionUpdateActionSchedule: {
    value: "action.update_action_schedule",
    displayName: "Action schedule updated",
  },
  ActionDeleteActionSchedule: {
    value: "action.delete_action_schedule",
    displayName: "Action schedule deleted",
  },
  // Deprecated: no matching value in api-accounts-history's activities.go;
  // kept for backwards compatibility with historical records.
  ActionUpdateActionPriorities: {
    value: "action.update_action_priorities",
    displayName: "Action priority due interval updated",
  },
  ActionUpdateActionPrioritySetting: {
    value: "action.update_action_priority_setting",
    displayName: "Action priority due interval updated",
  },
  ActionCreateLabel: {
    value: "action.create_action_label",
    displayName: "Action label created",
  },
  ActionUpdateLabel: {
    value: "action.update_action_label",
    displayName: "Action label updated",
  },
  ActionDeleteLabels: {
    value: "action.delete_action_labels",
    displayName: "Action labels deleted",
  },
  ActionsDeleted: {
    value: "action.actions_deleted",
    displayName: "Actions deleted",
  },
  ActionTemplateLinked: {
    value: "action.link_task_template",
    displayName: "Template linked to task",
  },
  ActionTemplateUnlinked: {
    value: "action.unlink_task_template",
    displayName: "Template unlinked from task",
  },
  ActionInspectionLinked: {
    value: "action.link_task_inspection",
    displayName: "Inspection linked to task",
  },
  ActionInspectionUnlinked: {
    value: "action.unlink_task_inspection",
    displayName: "Inspection unlinked from task",
  },
  CreateActionField: {
    value: "action.create_action_field",
    displayName: "Action field created",
  },
  DeleteActionField: {
    value: "action.delete_action_field",
    displayName: "Action field deleted",
  },
  UpdateActionField: {
    value: "action.update_action_field",
    displayName: "Action field renamed",
  },
  CreateActionType: {
    value: "action.create_action_type",
    displayName: "Action type created",
  },
  DeleteActionType: {
    value: "action.delete_action_type",
    displayName: "Action type deleted",
  },
  UpdateActionType: {
    value: "action.update_action_type",
    displayName: "Action type renamed",
  },
  MapFieldToType: {
    value: "action.map_field_to_type",
    displayName: "Action map field to type",
  },
  UnmapFieldToType: {
    value: "action.unmap_field_to_type",
    displayName: "Action un-map field to type",
  },
  AssetCreated: {
    value: "assets.create_asset",
    displayName: "Asset created",
  },
  AssetUpdated: {
    value: "assets.update_asset",
    displayName: "Asset updated",
  },
  AssetArchived: {
    value: "assets.archive_asset",
    displayName: "Asset archived",
  },
  AssetRestored: {
    value: "assets.restore_asset",
    displayName: "Asset restored",
  },
  AssetDeleted: {
    value: "assets.delete_asset",
    displayName: "Asset deleted",
  },
  AssetsBulkCreated: {
    value: "assets.bulk_create_assets",
    displayName: "Assets bulk created",
  },
  AssetsBulkUpdated: {
    value: "assets.bulk_update_assets",
    displayName: "Assets bulk updated",
  },
  AssetsUpdatedSite: {
    value: "assets.update_assets_site",
    displayName: "Asset's site updated",
  },
  AssetsBulkArchived: {
    value: "assets.bulk_archive_assets",
    displayName: "Assets bulk archived",
  },
  AssetsBulkRestored: {
    value: "assets.bulk_restore_assets",
    displayName: "Assets bulk restored",
  },
  AssetsBulkDeleted: {
    value: "assets.bulk_delete_assets",
    displayName: "Assets bulk deleted",
  },
  AssetTypeCreated: {
    value: "assets.create_asset_type",
    displayName: "Asset type created",
  },
  AssetTypeUpdated: {
    value: "assets.update_asset_type",
    displayName: "Asset type updated",
  },
  AssetTypeDeleted: {
    value: "assets.delete_asset_type",
    displayName: "Asset type deleted",
  },
  AssetTypeFieldCreated: {
    value: "assets.create_asset_field",
    displayName: "Asset type field created",
  },
  AssetTypeFieldUpdated: {
    value: "assets.update_asset_field",
    displayName: "Asset type field updated",
  },
  AssetTypeFieldDeleted: {
    value: "assets.delete_asset_field",
    displayName: "Asset type field deleted",
  },
  AssetTypeFieldMapped: {
    value: "assets.map_field_to_type",
    displayName: "Asset type field mapped",
  },
  AssetTypeFieldUnmapped: {
    value: "assets.unmap_field_to_type",
    displayName: "Asset type field unmapped",
  },
  AssetStatusGroupCreated: {
    value: "assets.create_status_group",
    displayName: "Asset status group created",
  },
  AssetStatusGroupUpdated: {
    value: "assets.update_status_group",
    displayName: "Asset status group updated",
  },
  AssetStatusGroupDeleted: {
    value: "assets.delete_status_group",
    displayName: "Asset status group deleted",
  },
  AssetStatusGroupAddedToTypes: {
    value: "assets.add_status_group_to_asset_types",
    displayName: "Asset status group added to asset types",
  },
  AssetStatusGroupRemovedFromTypes: {
    value: "assets.remove_status_group_from_asset_types",
    displayName: "Asset status group removed from asset types",
  },
  AssetReadingCreated: {
    value: "assets.create_asset_reading",
    displayName: "Asset reading created",
  },
  AssetReadingUpdated: {
    value: "assets.update_asset_reading",
    displayName: "Asset reading updated",
  },
  AssetReadingDeleted: {
    value: "assets.delete_asset_reading",
    displayName: "Asset reading deleted",
  },
  AuthLogin: {
    value: "auth.login",
    displayName: "Auth login",
  },
  AuthLogout: {
    value: "auth.logout",
    displayName: "Auth logout",
  },
  AuthSsoCreate: {
    value: "auth.sso_create",
    displayName: "SSO creation",
  },
  AuthSsoUpdate: {
    value: "auth.sso_update",
    displayName: "SSO update",
  },
  AuthSsoDelete: {
    value: "auth.sso_delete",
    displayName: "SSO deletion",
  },
  AuthApiTokenGenerated: {
    value: "auth.api_token_generated",
    displayName: "API token generated",
  },
  AuthTokenRefreshed: {
    value: "auth.token_refreshed",
    displayName: "Auth token refreshed",
  },
  AuthPasswordResetSecurity: {
    value: "auth.password_reset_security",
    displayName: "Password reset for security",
  },
  ScimUserAdded: {
    value: "scim.user_added",
    displayName: "SCIM user added",
  },
  ScimUserRemoved: {
    value: "scim.user_removed",
    displayName: "SCIM user removed",
  },
  ScimUserUpdated: {
    value: "scim.user_updated",
    displayName: "SCIM user updated",
  },
  GroupUserRemoved: {
    value: "group.user_removed",
    displayName: "User removed from group",
  },
  GroupUserAdded: {
    value: "group.memberships_modified",
    displayName: "Users added to groups",
  },
  GroupCreated: {
    value: "group.created",
    displayName: "Created group",
  },
  GroupUserAddedLegacy: {
    value: "group.user_added",
    displayName: "User added to group",
  },
  GroupGroupCreated: {
    value: "group.group_created",
    displayName: "Group created",
  },
  GroupGroupDeleted: {
    value: "group.group_deleted",
    displayName: "Group deleted",
  },
  GroupGroupUpdated: {
    value: "group.group_updated",
    displayName: "Group updated",
  },
  GroupGroupUsersAdded: {
    value: "group.group_users_added",
    displayName: "Users added to group",
  },
  GroupGroupUsersRemoved: {
    value: "group.group_users_removed",
    displayName: "Users removed from group",
  },
  InspectionArchived: {
    value: "inspection.archived",
    displayName: "Inspection archived",
  },
  InspectionCompleted: {
    value: "inspection.completed",
    displayName: "Inspection completed",
  },
  InspectionStarted: {
    value: "inspection.started",
    displayName: "Inspection started",
  },
  InspectionDeleted: {
    value: "inspection.deleted",
    displayName: "Inspection deleted",
  },
  InspectionUnarchived: {
    value: "inspection.unarchived",
    displayName: "Inspection unarchived",
  },
  InspectionCloned: {
    value: "inspection.cloned",
    displayName: "Inspection duplicated",
  },
  InspectionReportViewed: {
    value: "inspection.report_viewed",
    displayName: "Inspection report viewed",
  },
  InspectionReportShared: {
    value: "inspection.report_shared",
    displayName: "Inspection report shared",
  },
  InspectionReportLinkCreated: {
    value: "inspection.report_link_created",
    displayName: "Public inspection report link created",
  },
  InspectionReportLinkDisabled: {
    value: "inspection.report_link_disabled",
    displayName: "Public inspection report link disabled",
  },
  InspectionReportExported: {
    value: "inspection.report_exported",
    displayName: "Inspection report(s) downloaded",
  },
  OrgUserAdded: {
    value: "org.user_added", // Events from Mullet
    displayName: "User added to organisation",
  },
  OrgUsersAdded: {
    value: "org.users_added",
    displayName: "Users added to organisation",
  },
  OrgUserActivated: {
    value: "org.user_activated",
    displayName: "User activated",
  },
  OrgUserDeactivated: {
    value: "org.user_deactivated",
    displayName: "User deactivated",
  },
  OrgUserInviteAccepted: {
    value: "org.user_invite_accepted",
    displayName: "User invite to organisation accepted",
  },
  OrgUserInvited: {
    value: "org.user_invited",
    displayName: "User invited to organisation",
  },
  OrgUserRemoved: {
    value: "org.user_removed",
    displayName: "User removed from organisation",
  },
  OrgUserDeleted: {
    value: "org.user_deleted",
    displayName: "User deleted from organisation",
  },
  OrgUserNameUpdated: {
    value: "org.update_user_name",
    displayName: "User first/last name updated",
  },
  OrgUserTimezoneUpdated: {
    value: "org.update_user_timezone",
    displayName: "User timezone updated",
  },
  OrgUserEmailUpdated: {
    value: "org.update_user_email",
    displayName: "User email updated",
  },
  OrgUserSeatTypeUpdated: {
    value: "org.update_user_seat_type",
    displayName: "User seat type updated",
  },
  OrgUpdateUserPassword: {
    value: "org.update_user_password",
    displayName: "User password updated",
  },
  OrgUserFieldCreated: {
    value: "org.user_field_created",
    displayName: "User field created",
  },
  OrgUserFieldArchived: {
    value: "org.user_field_archived",
    displayName: "User field archived",
  },
  OrgUserFieldRestored: {
    value: "org.user_field_restored",
    displayName: "User field restored",
  },
  OrgUserFieldDeleted: {
    value: "org.user_field_deleted",
    displayName: "User field deleted",
  },
  OrgUserFieldModified: {
    value: "org.user_field_modified",
    displayName: "User field modified",
  },
  OrgUserAttributeModified: {
    value: "org.user_attribute_modified",
    displayName: "User attribute modified",
  },
  OrgUpdateUserDetails: {
    value: "org.update_user_details",
    displayName: "User details updated",
  },
  OrgUserUpdates: {
    value: "org.user_updates",
    displayName: "Series of user updates",
  },
  TemplateArchived: {
    value: "template.archived",
    displayName: "Template archived",
  },
  TemplateCreated: {
    value: "template.created",
    displayName: "Template created",
  },
  TemplateDeleted: {
    value: "template.deleted",
    displayName: "Template deleted",
  },
  TemplateUnarchived: {
    value: "template.unarchived",
    displayName: "Template unarchived",
  },
  TemplateFolderCreated: {
    value: "template.folder_created",
    displayName: "Template folder created",
  },
  TemplateFolderDeleted: {
    value: "template.folder_deleted",
    displayName: "Template folder deleted",
  },
  TemplateFolderUpdated: {
    value: "template.folder_updated",
    displayName: "Template folder updated",
  },
  TemplateShareCreated: {
    value: "template.share_created",
    displayName: "Template share invite sent",
  },
  TemplateShareAccepted: {
    value: "template.share_accepted",
    displayName: "Template share invite accepted",
  },
  CredentialTypeCreated: {
    value: "credential.type_created",
    displayName: "Credential Type created",
  },
  CredentialTypeUpdated: {
    value: "credential.type_updated",
    displayName: "Credential Type updated",
  },
  CredentialTypeDeleted: {
    value: "credential.type_deleted",
    displayName: "Credential Type deleted",
  },
  CredentialApproved: {
    value: "credential.approved",
    displayName: "Credential approved",
  },
  CredentialRejected: {
    value: "credential.rejected",
    displayName: "Credential rejected",
  },
  CredentialResubmitted: {
    value: "credential.resubmitted",
    displayName: "Credential resubmitted",
  },
  CredentialCreated: {
    value: "credential.created",
    displayName: "Credential created",
  },
  CredentialRenewed: {
    value: "credential.renewed",
    displayName: "Credential renewed",
  },
  CredentialVersionAdded: {
    value: "credential.version_added",
    displayName: "Credential version added",
  },
  CredentialViewed: {
    value: "credential.viewed",
    displayName: "Credential viewed",
  },
  CredentialDeleted: {
    value: "credential.deleted",
    displayName: "Credential deleted",
  },
  CredentialMediaDeletedSingle: {
    value: "credential.media_deleted_single",
    displayName: "Credential media item deleted",
  },
  CredentialMediaDeletedAll: {
    value: "credential.media_deleted_all",
    displayName: "Credential media deleted (all)",
  },
  CredentialBulkUpload: {
    value: "credential.bulk_upload",
    displayName: "Credentials bulk uploaded",
  },
  CredentialsExport: {
    value: "credential.export",
    displayName: "Credentials exported",
  },
  CredentialSettingsUpdated: {
    value: "credential.settings_updated",
    displayName: "Credential settings updated",
  },
  CredentialArchived: {
    value: "credential.archived",
    displayName: "Credential archived",
  },
  CredentialRestored: {
    value: "credential.restored",
    displayName: "Credential restored",
  },
  CredentialBulkArchived: {
    value: "credential.bulk_archived",
    displayName: "Credentials bulk archived",
  },
  CredentialBulkRestored: {
    value: "credential.bulk_restored",
    displayName: "Credentials bulk restored",
  },
  CredentialBulkDeleted: {
    value: "credential.bulk_deleted",
    displayName: "Credentials bulk deleted",
  },
  CompanyCreated: {
    value: "company.created",
    displayName: "Company created",
  },
  CompanyUpdated: {
    value: "company.updated",
    displayName: "Company updated",
  },
  CompanyDeleted: {
    value: "company.deleted",
    displayName: "Company deleted",
  },
  CompanyBulkUpload: {
    value: "company.bulk_upload",
    displayName: "Companies bulk uploaded",
  },
  CompanyBulkDelete: {
    value: "company.bulk_delete",
    displayName: "Companies bulk deleted",
  },
  CompanyUserAdded: {
    value: "company.user_added",
    displayName: "User added to company",
  },
  CompanyUserRemoved: {
    value: "company.user_removed",
    displayName: "User removed from company",
  },
  CompanyOrgSettingsUpdated: {
    value: "company.org_settings_updated",
    displayName: "Company org settings updated",
  },
  CompanyRequirementsUpdated: {
    value: "company.requirements_updated",
    displayName: "Company requirements updated",
  },
  CompanyUserRolesSet: {
    value: "company.user_roles_set",
    displayName: "Company user roles set",
  },
  SiteDeleted: {
    value: "site.deleted",
    displayName: "Site deleted",
  },
  SiteCreated: {
    value: "site.created",
    displayName: "Site created",
  },
  SiteUpdated: {
    value: "site.updated",
    displayName: "Site updated",
  },
  SiteSettingsUpdated: {
    value: "site.settings_updated",
    displayName: "Site settings updated",
  },
  SiteLabelsUpdated: {
    value: "site.labels_updated",
    displayName: "Site labels updated",
  },
  SiteAssociationsModified: {
    value: "site.associations_modified",
    displayName: "Site membership updated",
  },
  SubBillingDetailsUpdated: {
    value: "subscription.billing_details_updated",
    displayName: "Billing details updated",
  },
  SubUpgradeToPremium: {
    value: "subscription.upgrade_to_premium",
    displayName: "Upgraded organisation to premium plan",
  },
  SubCreateTrialSubscription: {
    value: "subscription.create_trial",
    displayName: "Created trial subscription",
  },
  SubReactivatePlan: {
    value: "subscription.reactivate_plan",
    displayName: "Reactivate organisation plan",
  },
  SubDowngradeToFree: {
    value: "subscription.downgrade_to_free",
    displayName: "Downgraded organisation to free plan",
  },
  SubPaymentMethodUpdated: {
    value: "subscription.payment_method_updated",
    displayName: "Updated payment method",
  },
  SubCancelAtEndOfPeriod: {
    value: "subscription.cancel_at_end_of_period",
    displayName: "Cancel at end of period updated",
  },
  SubAllocateComponents: {
    value: "subscription.allocate_components",
    displayName: "Seat quantity updated",
  },
  // Deprecated: no matching value in api-accounts-history's activities.go;
  // kept for backwards compatibility with historical records.
  SubConvertComponent: {
    value: "subscription.convert_component",
    displayName: "Seat converted",
  },
  SubSeatsReconciled: {
    value: "subscription.seats_reconciled",
    displayName: "Seats reconciled",
  },
  SubAiCreditOverageLimitUpdated: {
    value: "subscription.ai_credit_overage_limit_updated",
    displayName: "AI credit overage limit updated",
  },
  SubPONumberUpdated: {
    value: "subscription.zuora_po_number_updated",
    displayName: "Purchase order number updated",
  },
  SensorMetadataUpdated: {
    value: "sensor.sensor_metadata_updated",
    displayName: "Sensor details updated",
  },
  SensorLocationNameUpdated: {
    value: "sensor.sensor_location_name_updated",
    displayName: "Sensor location name updated",
  },
  SensorThresholdConfigurationUpdated: {
    value: "sensor.threshold_configuration_updated",
    displayName: "Sensor alert configurations updated",
  },
  SensorDisconnectionAlertConfigurationUpdated: {
    value: "sensor.disconnection_alert_configuration_updated",
    displayName: "Sensor disconnection alert configuration updated",
  },
  SensorLowBatteryAlertConfigurationUpdated: {
    value: "sensor.low_battery_alert_configuration_updated",
    displayName: "Sensor low battery alert configuration updated",
  },
  SensorWeatherAlertConfigurationUpdated: {
    value: "sensor.weather_alert_configuration_updated",
    displayName: "Sensor weather alert configuration updated",
  },
  SensorGatewayDetailsUpdated: {
    value: "sensor.gateway_details_updated",
    displayName: "Gateway details updated",
  },
  SensorGatewayAdded: {
    value: "sensor.gateway_provisioned",
    displayName: "Gateway added",
  },
  SensorGatewayRemoved: {
    value: "sensor.gateway_deprovisioned",
    displayName: "Gateway removed",
  },
  SensorProvisioned: {
    value: "sensor.sensor_provisioned",
    displayName: "Sensor provisioned",
  },
  SensorArchived: {
    value: "sensor.sensor_archived",
    displayName: "Sensor archived",
  },
  SensorUnarchived: {
    value: "sensor.sensor_unarchived",
    displayName: "Sensor unarchived",
  },
  DocumentsBulkUpload: {
    value: "document.bulk_upload",
    displayName: "Documents bulk upload",
  },
  DocumentsBulkArchive: {
    value: "document.bulk_archive",
    displayName: "Documents bulk archive",
  },
  DocumentsBulkRestore: {
    value: "document.bulk_restore",
    displayName: "Documents bulk restore",
  },
  DocumentsDocumentUpdate: {
    value: "document.document_update",
    displayName: "Documents updated",
  },
  DocumentsFolderCreate: {
    value: "document.folder_create",
    displayName: "Documents folder created",
  },
  DocumentsFolderRename: {
    value: "document.folder_rename",
    displayName: "Documents folder renamed",
  },
  DocumentsLabelCreate: {
    value: "document.label_create",
    displayName: "Documents label created",
  },
  DocumentsLabelDelete: {
    value: "document.label_delete",
    displayName: "Documents label deleted",
  },
  DocumentsLabelRename: {
    value: "document.label_rename",
    displayName: "Documents label renamed",
  },
  DocumentsDocumentLink: {
    value: "document.document_link",
    displayName: "Documents file linked",
  },
  DocumentsDocumentUnlink: {
    value: "document.document_unlink",
    displayName: "Documents file unlinked",
  },
  DocumentsDelete: {
    value: "document.document_folder_delete",
    displayName: "Documents file or folder deleted",
  },
  DocumentsBulkUpdateOwners: {
    value: "document.bulk_update_owners",
    displayName: "Documents owners updated",
  },
  DocumentsBulkAddOwners: {
    value: "document.bulk_add_owners",
    displayName: "Documents owners added",
  },
  PermissionSetCreated: {
    value: "permissions.create_permission_set",
    displayName: "Permission set created",
  },
  PermissionSetUpdated: {
    value: "permissions.update_permission_set",
    displayName: "Permission set updated",
  },
  PermissionSetDeleted: {
    value: "permissions.delete_permission_set",
    displayName: "Permission set deleted",
  },
  PermissionSetAssigned: {
    value: "permissions.assign_permission_set",
    displayName: "Permission set assigned",
  },
  RoleCreated: {
    value: "roles.create_role",
    displayName: "Role created",
  },
  RoleUpdated: {
    value: "roles.update_role",
    displayName: "Role updated",
  },
  RoleDeleted: {
    value: "roles.delete_role",
    displayName: "Role deleted",
  },
  RoleAssignedToUser: {
    value: "roles.assign_user_to_role",
    displayName: "User assigned to role",
  },
  RoleUnassignedFromUser: {
    value: "roles.unassign_user_from_role",
    displayName: "User removed from role",
  },
  SettingModified: {
    value: "setting.modified",
    displayName: "Setting modified",
  },
  CustomNavUpdated: {
    value: "setting.custom_nav_updated",
    displayName: "Custom navigation settings updated",
  },
  CustomNavOrgOverrideEnabled: {
    value: "setting.custom_nav_override_enabled",
    displayName: "Custom navigation org override updated",
  },
  HomeConfigurationUpdated: {
    value: "setting.home_configuration_updated",
    displayName: "Home configuration updated",
  },
  InstallIntegration: {
    value: "integrations.install",
    displayName: "Integration installed",
  },
  UninstallIntegration: {
    value: "integrations.uninstall",
    displayName: "Integration uninstalled",
  },
  IssueCreated: {
    value: "issue.created",
    displayName: "Issue created",
  },
  IssueDeleted: {
    value: "issue.deleted",
    displayName: "Issue deleted",
  },
  IssueCategoryCreated: {
    value: "issue.category_created",
    displayName: "Issue category created",
  },
  IssueCategoryDeleted: {
    value: "issue.category_deleted",
    displayName: "Issue category deleted",
  },
  IssueCategoryVisibilityUpdated: {
    value: "issue.category_visibility_updated",
    displayName: "Issue category visibility updated",
  },
  IssueCategoryNotificationsUpdated: {
    value: "issue.category_notifications_updated",
    displayName: "Issue category notifications updated",
  },
  IssueCategoryNotificationSettingsUpdated: {
    value: "issue.category_notification_settings_updated",
    displayName: "Issue category notification settings updated",
  },
  IssueCategoryFieldsUpdated: {
    value: "issue.category_fields_updated",
    displayName: "Issue category fields updated",
  },
  ContentLibraryContentImported: {
    value: "content_library.content_imported",
    displayName: "Content imported from content library",
  },
  ContentLibraryContentUpdatedAndPublishedToLatest: {
    value: "content_library.update_and_publish_product_to_latest",
    displayName:
      "Content library product updated and published to latest version",
  },
  ContentLibraryProductDeletedByAdmin: {
    value: "content_library.product_deleted_by_admin",
    displayName: "Content library product deleted",
  },
  ContentLibraryPublisherCreated: {
    value: "content_library.publisher_created",
    displayName: "Content library publisher created",
  },
  ContentLibraryPublisherUpdated: {
    value: "content_library.publisher_updated",
    displayName: "Content library publisher updated",
  },
  ContentLibraryProductPublished: {
    value: "content_library.product_published",
    displayName: "Content published",
  },
  ContentLibraryProductUnpublished: {
    value: "content_library.product_unpublished",
    displayName: "Content unpublished",
  },
  ContentLibraryProductMetadataUpdated: {
    value: "content_library.product_metadata_updated",
    displayName: "Content updated",
  },
  ContentLibraryProductCategoriesUpdated: {
    value: "content_library.product_categories_updated",
    displayName: "Content categories updated",
  },
  ContentLibraryProductCreated: {
    value: "content_library.product_created",
    displayName: "Content library product created",
  },
  ContentLibraryProductDeleted: {
    value: "content_library.product_deleted",
    displayName: "Content library product deleted",
  },
  ContentLibraryProductUpdated: {
    value: "content_library.product_updated",
    displayName: "Content library product updated",
  },
  ScheduleCreated: {
    value: "schedule.created",
    displayName: "Schedule Created",
  },
  ScheduleUpdated: {
    value: "schedule.updated",
    displayName: "Schedule Updated",
  },
  ScheduleDeleted: {
    value: "schedule.deleted",
    displayName: "Schedule Deleted",
  },
  ScheduleEnded: {
    value: "schedule.ended",
    displayName: "Schedule Ended",
  },
  SchedulePaused: {
    value: "schedule.paused",
    displayName: "Schedule Paused",
  },
  ScheduleResumed: {
    value: "schedule.resumed",
    displayName: "Schedule Resumed",
  },
  ScheduleAccessUpdated: {
    value: "schedule.access_updated",
    displayName: "Schedule Access Updated",
  },
  HeadsUpCreated: {
    value: "heads_up.created",
    displayName: "Heads Up Created",
  },
  HeadsUpUpdated: {
    value: "heads_up.updated",
    displayName: "Heads Up Updated",
  },
  HeadsUpDeleted: {
    value: "heads_up.deleted",
    displayName: "Heads Up Deleted",
  },
  RuleCreated: {
    value: "rule.rule_created",
    displayName: "Rule created",
  },
  RuleDeleted: {
    value: "rule.rule_deleted",
    displayName: "Rule deleted",
  },
  RuleUpdated: {
    value: "rule.rule_updated",
    displayName: "Rule updated",
  },
  NotificationSent: {
    value: "notification_sent",
    displayName: "Notification sent",
  },
  PrivilegesModifyPrivileges: {
    value: "privileges.modify_privileges",
    displayName: "Privileges modified",
  },
  OrgNotificationPrefWorkflowUpdated: {
    value: "org_notification_preference.workflows_updated",
    displayName: "Notifications workflows modified",
  },
  OrgNotificationPrefChannelsUpdated: {
    value: "org_notification_preference.channels_updated",
    displayName: "Notifications channel modified",
  },
  StructureFieldCreated: {
    value: "structure.field_created",
    displayName: "Structure field created",
  },
  StructureFieldUpdated: {
    value: "structure.field_updated",
    displayName: "Structure field updated",
  },
  StructureFieldsArchived: {
    value: "structure.fields_archived",
    displayName: "Structure fields archived",
  },
  StructureFieldsRestored: {
    value: "structure.fields_restored",
    displayName: "Structure fields restored",
  },
  ManufacturingLineCreated: {
    value: "manufacturing.line_created",
    displayName: "Production line created",
  },
  ManufacturingLineUpdated: {
    value: "manufacturing.line_updated",
    displayName: "Production line updated",
  },
  ManufacturingLineDeleted: {
    value: "manufacturing.line_deleted",
    displayName: "Production line deleted",
  },
  ManufacturingLineDuplicated: {
    value: "manufacturing.line_duplicated",
    displayName: "Production line duplicated",
  },
  ManufacturingAreaCreated: {
    value: "manufacturing.area_created",
    displayName: "Production area created",
  },
  ManufacturingAreaUpdated: {
    value: "manufacturing.area_updated",
    displayName: "Production area updated",
  },
  ManufacturingAreaDeleted: {
    value: "manufacturing.area_deleted",
    displayName: "Production area deleted",
  },
  ManufacturingTemplateCreated: {
    value: "manufacturing.template_created",
    displayName: "Production area template created",
  },
  ManufacturingTemplateUpdated: {
    value: "manufacturing.template_updated",
    displayName: "Production area template updated",
  },
  ManufacturingTemplateDeleted: {
    value: "manufacturing.template_deleted",
    displayName: "Production area template deleted",
  },
  ManufacturingTemplateDuplicated: {
    value: "manufacturing.template_duplicated",
    displayName: "Production area template duplicated",
  },
  ManufacturingCheckCreated: {
    value: "manufacturing.check_created",
    displayName: "Production check added to a template",
  },
  ManufacturingCheckUpdated: {
    value: "manufacturing.check_updated",
    displayName: "Production check updated",
  },
  ManufacturingCheckDeleted: {
    value: "manufacturing.check_deleted",
    displayName: "Production check removed from a template",
  },
  ManufacturingCheckTypeCreated: {
    value: "manufacturing.check_type_created",
    displayName: "Production check type created",
  },
  ManufacturingCheckTypeUpdated: {
    value: "manufacturing.check_type_updated",
    displayName: "Production check type updated",
  },
  ManufacturingCheckTypeDeleted: {
    value: "manufacturing.check_type_deleted",
    displayName: "Production check type deleted",
  },
  ManufacturingOptionAdded: {
    value: "manufacturing.option_added",
    displayName: "Production check type option added",
  },
  ManufacturingOptionUpdated: {
    value: "manufacturing.option_updated",
    displayName: "Production check type option updated",
  },
  ManufacturingOptionRemoved: {
    value: "manufacturing.option_removed",
    displayName: "Production check type option removed",
  },
  ManufacturingCriteriaCreated: {
    value: "manufacturing.criteria_created",
    displayName: "Production criteria created",
  },
  ManufacturingCriteriaUpdated: {
    value: "manufacturing.criteria_updated",
    displayName: "Production criteria updated",
  },
  ManufacturingCriteriaDeleted: {
    value: "manufacturing.criteria_deleted",
    displayName: "Production criteria deleted",
  },
  ManufacturingProductCreated: {
    value: "manufacturing.product_created",
    displayName: "Production product created",
  },
  ManufacturingProductUpdated: {
    value: "manufacturing.product_updated",
    displayName: "Production product updated",
  },
  ManufacturingProductDeleted: {
    value: "manufacturing.product_deleted",
    displayName: "Production product deleted",
  },
  ManufacturingProductDuplicated: {
    value: "manufacturing.product_duplicated",
    displayName: "Production product duplicated",
  },
  ManufacturingProductsImported: {
    value: "manufacturing.products_imported",
    displayName: "Production products imported",
  },
  ManufacturingProductSitesSet: {
    value: "manufacturing.product_sites_set",
    displayName: "Production product sites set",
  },
  ManufacturingSiteSettingsUpdated: {
    value: "manufacturing.site_settings_updated",
    displayName: "Production site settings updated",
  },
  ManufacturingSetupApplied: {
    value: "manufacturing.setup_applied",
    displayName: "Production setup applied",
  },
  ManufacturingDemoDataFilled: {
    value: "manufacturing.demo_data_filled",
    displayName: "Production demo data filled",
  },
} as const;

// Type for Activity values (string literal union)
export type ActivityValue =
  (typeof Activities)[keyof typeof Activities]["value"];

// Category overrides for activity types (by default, category is extracted from activity value)
export const CategoryOverrides: Record<string, string> = {
  action: "Actions",
  auth: "Authorization",
  content_library: "Content Library",
  credential: "Credentials",
  document: "Documents",
  group: "Group Management",
  heads_up: "Heads Up",
  inspection: "Inspections",
  issue: "Issues",
  org: "User Management",
  permissions: "Permissions",
  roles: "Roles",
  rule: "Dynamic Rules",
  schedule: "Schedules",
  scim: "SCIM",
  sensor: "Sensors",
  setting: "Settings",
  site: "Sites",
  subscription: "Billing",
  template: "Templates",
  structure: "Structures",
  manufacturing: "Production",
};

export const GetActivityTypeDisplayName = (
  activity: string,
  metadata?: Record<string, string>,
): string => {
  // AddUsersToStructure / RemoveUsersFromStructure collapse into the role
  // assign/unassign event types upstream (api-accounts-history). When metadata
  // is present but carries no role_id, the action is a plain site/group
  // membership change rather than a role assignment, so use membership-framed
  // copy. Require non-empty metadata so a metadata-less event falls back to the
  // default role label instead of being mislabelled as a membership change.
  const isMembershipChange =
    !!metadata && Object.keys(metadata).length > 0 && !metadata.role_id;
  if (isMembershipChange) {
    if (activity === Activities.RoleAssignedToUser.value) {
      return "User added to site or group";
    }
    if (activity === Activities.RoleUnassignedFromUser.value) {
      return "User removed from site or group";
    }
  }

  // Find the matching activity in Activities
  const activityEntry = Object.values(Activities).find(
    (a) => a.value === activity,
  );
  return activityEntry?.displayName || activity;
};

interface ClientClassMap {
  [clientClass: string]: ClientClass;
}

export enum ClientClass {
  INC_DEVICE = "inc_device",
  SC_API = "sc_web",
  SC_DEVICE = "sc_device",
  SC_INTEGRATIONS = "sc_integration",
  SC_SERVICE = "sc_service",
  SC_SUDO = "sc_sudo",
  SUDO = "sudo",
  SC_WEB = "sc_web",
}

export const ClientClassMapper: ClientClassMap = {
  inc_device: ClientClass.INC_DEVICE,
  sc_api: ClientClass.SC_API,
  sc_device: ClientClass.SC_DEVICE,
  sc_integrations: ClientClass.SC_INTEGRATIONS,
  sc_service: ClientClass.SC_SERVICE,
  sc_sudo: ClientClass.SC_SUDO,
  sc_web: ClientClass.SC_WEB,
  sudo: ClientClass.SC_SUDO,
};

interface ClientClassDisplayMap {
  [clientClass: string]: string;
}
export const ClientClassDisplayMapper: ClientClassDisplayMap = {
  inc_device: "Inc Device",
  sc_api: "API",
  sc_device: "Device",
  sc_integrations: "Integration",
  sc_service: "Service",
  sc_sudo: "Sudo",
  sudo: "Sudo",
  sc_web: "Web",
  web: "Web",
  mobile: "Device",
};

export enum Initiator {
  UNKNOWN = "INITIATOR_UNKNOWN",
  USER = "INITIATOR_USER",
  SYSTEM = "INITIATOR_SYSTEM",
  PERISCOPE = "INITIATOR_PERISCOPE",
}

export const SYSTEM_INITIATOR_NAME = "Organization Admin";

/**
 * Extracts the category from an Activity value (e.g., "action.create_field" -> "action")
 */
const extractCategory = (activityValue: string): string => {
  const parts = activityValue.split(".");
  return parts.length > 1 ? parts[0] : activityValue;
};

/**
 * Builds a hierarchical structure from Activity enum and display names
 * Returns an array containing both category items and action items for use with Autocomplete
 */
export const buildHierarchicalActivityItems = (): FilterTypeItem[] => {
  // Group items by their extracted category
  const categoryMap = new Map<string, FilterTypeItem[]>();

  // Iterate through all Activities
  Object.values(Activities).forEach(({ value, displayName }) => {
    const category = extractCategory(value);

    // Get category display name from overrides or capitalize the category
    const categoryDisplayName =
      CategoryOverrides[category] ||
      category.charAt(0).toUpperCase() + category.slice(1);

    if (!categoryMap.has(category)) {
      categoryMap.set(category, []);
    }

    const categoryItems = categoryMap.get(category);
    if (categoryItems) {
      categoryItems.push({
        DisplayName: displayName,
        Category: categoryDisplayName,
        Value: value,
        parentCategory: category,
      });
    }
  });

  const result: FilterTypeItem[] = [];

  // Sort categories alphabetically by their display name
  const sortedCategories = Array.from(categoryMap.entries()).sort(
    ([keyA], [keyB]) => {
      const displayNameA =
        CategoryOverrides[keyA] || keyA.charAt(0).toUpperCase() + keyA.slice(1);
      const displayNameB =
        CategoryOverrides[keyB] || keyB.charAt(0).toUpperCase() + keyB.slice(1);
      return displayNameA.localeCompare(displayNameB);
    },
  );

  // Create category items and add both categories and their children to the result
  sortedCategories.forEach(([categoryKey, children]) => {
    // Get category display name from overrides or capitalize
    const categoryDisplayName =
      CategoryOverrides[categoryKey] ||
      categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1);

    const categoryItem: FilterTypeItem = {
      DisplayName: categoryDisplayName,
      Category: categoryDisplayName,
      Value: `category:${categoryKey}`, // Special value to identify categories
      isCategory: true,
      children: children,
    };

    // Add category first, then its children
    result.push(categoryItem);
    result.push(...children);
  });

  return result;
};

/**
 * Helper to determine if all children of a category are selected
 */
export const areAllChildrenSelected = (
  categoryItem: FilterTypeItem,
  selectedItems: FilterTypeItem[],
): boolean => {
  if (!categoryItem.children || categoryItem.children.length === 0) {
    return false;
  }

  const selectedValues = new Set(selectedItems.map((item) => item.Value));
  return categoryItem.children.every((child) =>
    selectedValues.has(child.Value),
  );
};

/**
 * Helper to get children of a category by category key
 */
export const getCategoryChildren = (
  categoryKey: string,
  allItems: FilterTypeItem[],
): FilterTypeItem[] => {
  return allItems.filter(
    (item) => !item.isCategory && item.parentCategory === categoryKey,
  );
};
